export default "__VITE_ASSET__Dgyv2MEi__"